import React from "react";
import { useFocusable } from "@noriginmedia/norigin-spatial-navigation";
import "./epg.scss";

const EPGLeagueCard = ({ league, onFocus, onEnterPress, index, rowId }) => {
    const { id, name, logo } = league;
    const focusKey = `league-${rowId}-${index}`;

    const { ref, focused } = useFocusable({
        focusKey,
        onEnterPress,
        onFocus: (focusProps) => {
            onFocus({
                ...focusProps,
                index,
            });
        },
        extraProps: {
            focusKey: id,
        },
    });

    return (
        <div ref={ref} className={`leagueItem ${focused ? "focusLeagueShortcut" : ""} `} onClick={() => onEnterPress({ focusKey: id })}>
            <button aria-label={`Filter by ${name}`} className="leagueItem" style={{ backgroundImage: `url(${logo})` }}></button>
        </div>
    );
};

export default EPGLeagueCard;
